import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const slider: DataBindingComponentModel = {
  panel: {
    height: 212,
    title: 'Connect_Panel_Title_Slider',
    helpId: 'b8ec278c-78a9-463f-b3ff-9112ed9e7e40',
  },
  sections: [
    {
      role: 'sliderRole',
      bindings: [
        {
          title: 'Connect_Panel_Connect_Slider_Value_Label',
          prop: 'value',
          supportedFieldTypes: [FieldType.number],
          defaultFieldType: FieldType.number,
          isInputProperty: true,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
